export default () => (
  <svg width='192' height='192' viewBox='0 0 192 192' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M96 165.6C134.439 165.6 165.6 134.439 165.6 96C165.6 57.561 134.439 26.4 96 26.4C57.561 26.4 26.4 57.561 26.4 96C26.4 134.439 57.561 165.6 96 165.6ZM168 96C168 135.765 135.765 168 96 168C56.2355 168 24 135.765 24 96C24 56.2355 56.2355 24 96 24C135.765 24 168 56.2355 168 96Z'
      fill='#FFF308'
      fillOpacity='0.2'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M95.6 156C128.958 156 156 128.958 156 95.6C156 62.242 128.958 35.2 95.6 35.2C62.242 35.2 35.2 62.242 35.2 95.6C35.2 128.958 62.242 156 95.6 156ZM159.2 95.6C159.2 130.725 130.725 159.2 95.6 159.2C60.4747 159.2 32 130.725 32 95.6C32 60.4747 60.4747 32 95.6 32C130.725 32 159.2 60.4747 159.2 95.6Z'
      fill='#FFF308'
      fillOpacity='0.6'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M95.6 149.6C125.423 149.6 149.6 125.423 149.6 95.6C149.6 65.7766 125.423 41.6 95.6 41.6C65.7766 41.6 41.6 65.7766 41.6 95.6C41.6 125.423 65.7766 149.6 95.6 149.6Z'
      fill='#FFEC65'
    />
    <path
      d='M167.315 73.0823C167.327 72.723 167.333 72.3622 167.333 72C167.333 54.3269 152.977 40 135.267 40C121.218 40 109.279 49.0156 104.944 61.5654C101.83 59.9438 98.2888 59.027 94.5333 59.027C82.0885 59.027 72 69.0946 72 81.5135C72 93.9324 82.0885 104 94.5333 104L135.31 104H159.533C168.628 104 176 96.6429 176 87.5675C176 81.3011 172.485 75.854 167.315 73.0823Z'
      fill='white'
    />
    <path
      d='M74.6556 130.08C74.663 129.857 74.6667 129.634 74.6667 129.41C74.6667 118.469 65.8318 109.6 54.9334 109.6C46.288 109.6 38.9411 115.181 36.2729 122.95C34.3567 121.946 32.1777 121.379 29.8667 121.379C22.2083 121.379 16 127.611 16 135.299C16 142.987 22.2083 149.219 29.8667 149.219L54.9599 149.219H69.8667C75.4632 149.219 80 144.665 80 139.047C80 135.167 77.837 131.795 74.6556 130.08Z'
      fill='white'
    />
  </svg>
);
